module.exports = __webpack_public_path__ + "static/img/bg3.93d1ee27.jpg";